import { useCallback, useEffect, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { HttpRequest } from "../../services/httpRequest";

export function SimpleNavbar(props) {
  const doc = localStorage.getItem("doc");
  const [, setFirstname] = useState("");

  const loadInfoUser = useCallback(async () => {
    try {
      const data = await HttpRequest.getInfoUser(doc);
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, [doc]);

  useEffect(() => {
    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    loadInfo()
      .then((basicInfo) => {
        setFirstname(basicInfo?.firstname);
      })
      .catch((e) => console.log(e));
  }, [loadInfoUser]);

  return (
    <Disclosure
      as="nav"
      className="fixed z-30 w-full bg-transparent font-walsheim text-lg"
    >
      {({ open }) => (
        <>
          <div className="px-4 sm:px-6 lg:px-20">
            <div className="flex justify-between h-24">
              <div className="flex">
                <a className="shrink-0 flex items-center" href="/">
                  <img
                    className="block md:hidden h-12 w-auto"
                    src="/svg/imagotipo-galilea-14.svg"
                    alt="Galilea"
                  />
                  <img
                    className="hidden md:block h-14 w-auto"
                    src="/svg/imagotipo-galilea-02.svg"
                    alt="Galilea"
                  />
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
}
